import { render, staticRenderFns } from "./CommunicationReaders.vue?vue&type=template&id=bfb2f3d8"
import script from "./CommunicationReaders.vue?vue&type=script&lang=ts"
export * from "./CommunicationReaders.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports